import { captureException } from '@sentry/nextjs';

export abstract class LoggerRepo {
  static logError(error: unknown) {
    captureException(error);
  }
}
